import React from 'react';
import selectionContext from './SelectionContext';

const useSelectionContext = () => React.useContext(selectionContext);

export default useSelectionContext;
